import { GuaranteeStatus, IReservation } from '@localina/core';
import { DateTime } from 'luxon';

/** End of the guest's free cancellation: the backend's value, else the reservation time minus the restaurant's notice. */
export const getFreeCancellationUntil = (reservation: IReservation, cancelNoticeHours?: number): string | undefined =>
    reservation.guarantee?.freeCancellationUntil ??
    (cancelNoticeHours !== undefined
        ? DateTime.fromISO(reservation.reservationDateTime).minus({ hours: cancelNoticeHours }).toISO() ?? undefined
        : undefined);

/**
 * A guest who can still cancel for free isn't a no-show yet: with a chargeable card, "no-show" waits for the end of
 * free cancellation (the backend refuses it too). Before that, staff cancel the reservation and the card is released.
 */
export const isNoShowTooEarly = (reservation: IReservation, cancelNoticeHours?: number, now = DateTime.now()) => {
    const status = reservation.guarantee?.status;
    if (status !== GuaranteeStatus.SECURED && status !== GuaranteeStatus.CHARGE_FAILED) {
        return false;
    }
    const until = getFreeCancellationUntil(reservation, cancelNoticeHours);
    return !!until && now < DateTime.fromISO(until);
};
